var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-toolbar-items',[_c('v-btn',{attrs:{"text":"","to":{name:'supplier-invoice-list'}}},[_vm._v("Factures fournisseurs")]),_c('v-btn',{attrs:{"text":"","to":{name:'prestations-list'}}},[_vm._v("Prestations")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }